/**
 * 暫存介面上輸入（未 submit）的資料
 * 不加入 localstorage
 **/
const state = () => ({
    assured: {
        name: null
    },
    agreements: { // 同意條款
        kyc: false, // 投保須知(review 頁面)
        product: false, // 商品保單條款(review 頁面)
        ePolicy: true, // 我瞭解本次交易以電子保單為主
        register: false, // 會員註冊事項(renewal review 頁面)
        declaration: false, // 聲明事項
        age65: false // 65歲KYC 
    },
});

const actions = {};

const getters = {};

const mutations = {
    clear(state) {
        state.agreements = {
            kyc: false,
            product: false,
            ePolicy: true,
            register: false,
            declaration: false,
            age65: false
        };
    },
    setValue(state, payload) {
        state[payload.key] = payload.value;
    },
    setAgreement(state, payload) {
        state.agreements[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};